import { TemplateType } from '../models/TemplateType';

export const getTemplateTitle = (type: TemplateType, title: string) => {
  if (type === TemplateType.QUIZ) {
    return title + ' trivia';
  }
  return title;
};
